export const ADMIN = 1;
export const REVIEWER = 2;
export const USER = 3;